export const USAGE_LABEL_COLORS: string[] = [
  '#E26D5C',
  '#EBA76C',
  '#F4E07C',
  '#B3D79B',
  '#72CDB9',
  '#6C9CA0',
  '#666A86',
  '#8E8BA8',
  '#B6ABC9',
  '#8B2719',
  '#A65917',
  '#C6A711',
  '#649D3F',
  '#2C7C6B',
  '#2E4547',
  '#23252E',
  '#444257',
  '#675685',
];
